import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

import { TProject } from '../types';

type TGetProjects = {
  projectSearch: string;
  workspaces: string[];
  clients: string[];
};

export async function getProjects({
  workspaces,
  clients,
  projectSearch,
}: TGetProjects): Promise<TProject[]> {
  return acceso360Client
    .get(`/monitoring/api/v1/projects`, {
      params: {
        limit: 25,
        ...(workspaces && workspaces.length > 0 && { workspace_id__in: workspaces.join(',') }),
        ...(clients && clients.length > 0 && { client_id__in: clients.join(',') }),
        ...(projectSearch && { search: projectSearch }),
      },
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getProjects;

interface UseProjectParams {
  config?: QueryConfig<QueryFnType>;
}

export function useProjects({ config = {} }: UseProjectParams = {}) {
  const { workspaces, clients, projectSearch } = useProgramBroadcastFilters();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['projects', { workspaces, clients, projectSearch }],
    queryFn() {
      return getProjects({ workspaces, clients, projectSearch });
    },
  });
}
